export interface SearchableMove {
  id: string | number;
  san?: string;
  annotation?: string;
  child_moves?: SearchableMove[];
}

export function searchMoveTree(
  tree: SearchableMove[] | undefined | null,
  query: string,
): Set<string | number> {
  const matches = new Set<string | number>();
  const trimmed = (query || '').trim().toLowerCase();
  if (!trimmed || !tree || tree.length === 0) return matches;

  const walk = (nodes: SearchableMove[]) => {
    for (const node of nodes) {
      const san = (node.san || '').toLowerCase();
      const annotation = (node.annotation || '').toLowerCase();
      if (san.includes(trimmed) || annotation.includes(trimmed)) {
        matches.add(node.id);
      }
      if (node.child_moves && node.child_moves.length > 0) {
        walk(node.child_moves);
      }
    }
  };
  walk(tree);
  return matches;
}
